/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import { fromLegacyTimeZone, toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import {
  RECOMMENDATION_TYPES,
  AUTO_APPLY_TYPES_NAMES,
  SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES
} from '@bingads-webui-campaign/recommendation-core';
import { getAutpApplyBannerStyle } from './style/apply-banner-style';

class RecommendationAutpApplyBanner extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    applyDate: PropTypes.number.isRequired,
    recommendationsCount: PropTypes.number.isRequired,
    appConfig: PropTypes.objectOf(PropTypes.any).isRequired,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
    isFromSummary: PropTypes.bool,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    callback: PropTypes.func,
    initializeMiniGrid: PropTypes.func,
    campaignAutoApplyStatus: PropTypes.shape({
      [RECOMMENDATION_TYPES.RESPONSIVE_SEARCH_ADS]: PropTypes.string,
    }),
    type: PropTypes.string.isRequired,
    optInStatus: PropTypes.bool.isRequired,
    permissions: PropTypes.shape({}),
    isAutoApplyRecommendationEnabled: PropTypes.bool.isRequired,
    viewSettings: PropTypes.func.isRequired,
  };

  static defaultProps = {
    campaignAutoApplyStatus: {},
    isFromSummary: false,
    callback: _.noop,
    initializeMiniGrid: _.noop,
    permissions: {},
  };

  componentDidMount() {
    const {
      isFromSummary,
      initializeMiniGrid,
    } = this.props;

    if (isFromSummary) {
      initializeMiniGrid();
    }
  }

  getAutoApplyString = () => {
    const {
      newI18n,
      applyDate,
      recommendationsCount,
      type,
      optInStatus,
      isAutoApplyRecommendationEnabled,
    } = this.props;

    let applyDateStr;
    let autoApplyPitching;
    if (isAutoApplyRecommendationEnabled) {
      applyDateStr = optInStatus && applyDate !== 0 ? this.formatDateWithAccountTimeZone(applyDate.toString()) : '';
      autoApplyPitching = !_.isEmpty(applyDateStr) ?
        newI18n.getString(
          recommendationsCount > 1 ? _TL_('{{recommendationsCount}} recommendations will apply on {{applyDateStr}} or later.') :
            _TL_('{{recommendationsCount}} recommendation will apply on {{applyDateStr}} or later.'),
          { recommendationsCount, applyDateStr }
        ) : newI18n.getString(
          recommendationsCount > 1 ? _TL_('{{recommendationsCount}} recommendations will apply later.') :
            _TL_('{{recommendationsCount}} recommendation will apply later.'),
          { recommendationsCount }
        );
    } else {
      applyDateStr = this.formatDateWithAccountTimeZone(_.isNumber(applyDate) ?
        applyDate.toString() : '');
      autoApplyPitching = newI18n.getString(
        _TL_('{{recommendationsCount}} {{recommendationName}} will apply on {{applyDateStr}} or later.'),
        { recommendationsCount, recommendationName: AUTO_APPLY_TYPES_NAMES[type], applyDateStr }
      );
    }

    return autoApplyPitching;
  }

  formatDateWithAccountTimeZone = (applyDateStr, timeZone = null) => {
    const { i18n, appConfig } = this.props;
    const applyDate = i18n.parseDate(`${applyDateStr.substring(0, 4)}/${applyDateStr.substring(4)}`, { raw: 'yyyy/MMddHHmmss', timeZone: 'UTC' });
    const accountTimeZone = toIANATimeZone(fromLegacyTimeZone(_.isNull(timeZone)
      ? appConfig.get('AccountTimeZone')
      : timeZone));

    // if applyDate is a past date, show current date instead.
    return i18n.formatDate(_.max([applyDate, new Date()]), { timeZone: accountTimeZone });
  }

  render() {
    const {
      newI18n,
      campaignAutoApplyStatus,
      isFromSummary,
      classes,
      callback,
      type,
      isAutoApplyRecommendationEnabled,
      viewSettings,
    } = this.props;

    if (campaignAutoApplyStatus[type] !== 'true') {
      return null;
    }

    if (!isFromSummary) {
      callback(campaignAutoApplyStatus);
    }

    const autoApplyString = this.getAutoApplyString();

    return (
      <div className={classNames('auto-apply-banner', classes.recommendationAutoApplyBanner)}>
        <span className="iconba iconba-FlashAuto" />
        <span>
          {autoApplyString}
          {!isFromSummary &&
            <React.Fragment>
              <span>{` ${newI18n.getString(_TL_('Manage auto-apply preferences in'))}`}</span>
              <button
                className="settings-page-link btn-link"
                onClick={() => viewSettings(_.contains(SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES, type))}
              >
                {isAutoApplyRecommendationEnabled &&
                _.contains(SUPPORT_ADINSIGHT_AUTO_APPLY_TYPES, type) ?
                newI18n.getString(_TL_('Auto-apply recommendation settings.')) : newI18n.getString(_TL_('Account settings.'))
                }
              </button>
            </React.Fragment>
          }
        </span>
      </div>
    );
  }
}

export const StyledRecommendationAutpApplyBanner =
  withDefaultStyles(RecommendationAutpApplyBanner, getAutpApplyBannerStyle);
